import React from 'react';

import FilterIcon from '@atlaskit/icon/core/filter';
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

import { useIntl } from 'src/hooks/intl';

import { useAnalytics } from '../settings/analytics';

import messages from './filter-control.i18n';

interface FilterControlProps {
  onFilterChange: (filter: string) => void;
}

export const FilterControl = ({
  onFilterChange,
}: FilterControlProps): JSX.Element => {
  const intl = useIntl();
  const { publishClickEvent } = useAnalytics();

  return (
    <Box
      xcss={xcss({
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        paddingTop: 'space.150',
        paddingBottom: 'space.100',
      })}
    >
      <Textfield
        name="filter-changetree-files-input"
        id="filter-changetree-files-input"
        testId="filter-changetree-files-input"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const filter = e.target.value;
          onFilterChange(filter);
        }}
        placeholder={intl.formatMessage(messages.filterLabel)}
        elemBeforeInput={
          <FilterIcon
            label={intl.formatMessage(messages.filterLabel)}
            spacing="spacious"
            color={token('color.text.subtlest')}
          />
        }
        onClick={() =>
          publishClickEvent({
            name: 'filterChangedFilesClick',
            actionSubject: 'textInput',
          })
        }
      />
    </Box>
  );
};
